import { useServices } from './useServices';

export const useLogger = () => {
  return useServices().logger;
};
